








import { Validator } from 'vee-validate'
import Vue from 'vue'
import { Component, Inject, Prop } from 'vue-property-decorator'

@Component
export default class Link extends Vue {
  @Inject()
  $validator: Validator

  @Prop()
  url: string

  @Prop()
  position: string
}
